import { frontendURL } from 'dashboard/helper/URLHelper.js';

import PipelinesIndex from './PipelinesIndex.vue';
import PipelineBoard from './PipelineBoard.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const pipelinesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipelines'),
      name: 'pipelines_index',
      meta,
      component: PipelinesIndex,
    },
    {
      path: frontendURL('accounts/:accountId/pipelines/:pipelineId'),
      name: 'pipeline_board',
      meta,
      component: PipelineBoard,
    },
  ],
};

export default pipelinesRoutes;
